module.exports = __webpack_public_path__ + "static/media/ilkley-27.7617c6b5.jpg";